// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'

import store from './store'
import router from './router'
import App from './App'

// import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import FastClick from 'fastclick'
import './common/css/index.css'
import '../static/ellips.css'
import animated from 'animate.css' 
Vue.use(animated)
// import ScratchCard from 'vue-scratch-card0'
import Vueclipboard from 'vue-clipboard2'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);
Vue.use(Vueclipboard)
// Vue.use(ImagePreview);
// Vue.prototype.$Base64 = require('js-base64').Base64;
Vue.config.productionTip = false;



FastClick.attach(document.body);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
// router.beforeEach((to, from, next) => {
//   // 需要登录
//   if (to.matched.some(function (item) {
//       return item.meta.login
//     })) {
//     if (!localStorage["token"]) {
//       next('/login')
//     } else {
//       // console.log(access.some(role=>{to.meta.role.includes(role)}))
//       if(to.meta.role.includes(access)){
//         next()
//       }else{
//         console.log(access)
//         next('/404')
//       }
//     }
//   } else {
//     next()
//   }
// })

// function hasPermission(roles, route) {
//   if (route.meta && route.meta.roles) {
//     return roles.some(role => route.meta.roles.includes(role))
//   } else {
//     return true
//   }
// }
// sessionStorage.setItem("token","555");
// router.beforeEach((to, from, next) => {
//     if (to.path === '/login') {
//       next({ path: '/' });
//     } else {
//       store.dispatch('GetInfo').then(res => { // 拉取info
//         const roles = res.data.role;
//         store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
//           router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
//           next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//         })
//       }).catch(err => {
//         console.log(err);
//       });
//     }
// });



// WEBPACK FOOTER //
// ./src/main.js